<template>
  <div>
    <div class="row" style="margin-bottom: 20px;">
      <div class="col-3">
        <span style="font-weight: bold;">{{ $gettext("CONTRACT_SERVICES") }}</span>
      </div>
      <div class="col-9" style="text-align: right;">
        <button tabindex="0" @click="openDialog()" type="button"
          class="q-btn q-btn-item non-selectable no-outline q-btn--standard q-btn--rectangle bg-secondary text-white q-btn--actionable q-focusable q-hoverable q-btn--wrap q-btn--active">
          <span class="q-focus-helper"></span>
          <span class="q-btn__wrapper col row q-anchor--skip">
            <span class="q-btn__content text-center col items-center q-anchor--skip justify-center row">
              <i aria-hidden="true" role="presentation"
                class="q-icon notranslate material-icons q-pr-md jt-data-table-button photos-btn">add_to_photos</i>
              {{ $gettext("NEW") }}
            </span>
          </span>
        </button>
      </div>
    </div>
    <div v-for="(service, index) in services" :key="index" style="margin-top: 20px;">
      <div>
        <div class="row" style="background: #757575; color: white; padding: 6px;">
          <div class="col-2">
            <span><b>Tp. Serviço:</b> <span>{{ service.serviceTypeText }}</span></span>
          </div>
          <div class="col-2">
            <span><b>Tp. Contrato:</b> <span>{{ service.contractTypeText }}</span></span>
          </div>
          <div class="col-2">
            <span><b>Faturamento:</b>
              <span>{{ service.billingMeasurementTypeText }}</span></span>
          </div>
          <div class="col-1">
            <span><b>{{ $gettext("MEASUREMENT_INIT") }}</b> <span>{{ service.measurementStart }}</span></span>
          </div>
          <div class="col-1">
            <span><b>Prioridade:</b> <span>{{ service.priority == '1' ? 'Sim' : 'Não' }}</span></span>
          </div>
          <div class="col-1">
            <span><b>Prest. de Serviço:</b> <span>{{ service.provisionOfService ? 'Sim' : 'Não' }}</span></span>
          </div>
          <div class="col-2">
            <span><b>Tp. Faturamento:</b> <span>{{ service.minimumBillingType }}</span></span>
          </div>
          <div class="col-1">
            <div class="mdi mdi-delete mdi-18px custom-cursor" @click="removeService(index)"></div>
          </div>
        </div>
        <table class="tabela" style="margin: 0px;">
          <thead>
            <tr>
              <th>{{ $gettext("LANDFILL_NAME") }}</th>
              <th>{{ $gettext("WASTE_TYPE") }}</th>
              <th>{{ $gettext("PRODUCT_DESCRIPTION") }}</th>
              <th>{{ $gettext("ITEM_VALUE") }}</th>
              <th>{{ $gettext("MINIMUM_BILLING") }}</th>
              <th>{{ $gettext("BID_QTD") }}</th>
              <th>{{ $gettext("CALCULATION") }}</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(contractItem, indexItem) in service.contractItems" :key="indexItem">
              <td class="align-column">{{ contractItem.landfillText }}</td>
              <td class="align-column">{{ contractItem.residueTypeText }}</td>
              <td class="align-column">{{ contractItem.productText }}</td>
              <td class="align-column text-ellipsis">
                <span v-if="!hasBillingItems(contractItem)" class="value-text tw-p-1 tw-rounded-md">
                  {{ getValueTextPrice(contractItem) }}
                </span>
                <div v-else>
                  <span v-for="contractItemBilling in contractItem.contractItemBilling" :key="contractItemBilling.id"
                    class="value-text tw-p-1 tw-rounded-md">
                    {{ getValueTextFromBillingItems(contractItemBilling) }}
                  </span>
                </div>
                <q-tooltip anchor="bottom middle" self="top middle" content-style="font-size: 13px" :offset="[5, 5]">
                  <div v-if="isValueRange(contractItem.serviceType)">
                    <div class="tooltip-range-area" :key="index" v-for="(itemBilling, index) in contractItem.contractItemBilling">
                        <span class="tooltip-range-item">{{ getQuantityMessage(itemBilling.quantity) }}</span>
                        <span class="tooltip-range-item">{{ getPriceMessage(itemBilling.value) }}</span>
                        <span v-if="!!itemBilling.contractItemBillingType" class="tooltip-range-item">{{ getContractItemBillingTypeMessage(itemBilling.contractItemBillingType) }}</span>
                    </div>
                  </div>
                  <div v-else>
                    {{ contractItem.unitPrice }}
                  </div>
                </q-tooltip>
              </td>
              <td class="align-column">{{ contractItem.minimalBilling }}</td>
              <td class="align-column">{{ contractItem.contractBidQuantity }}</td>
              <td class="align-column">{{ contractItem.unitMeasureTypeText }}</td>
              <td class="mdi mdi-pencil mdi-24px custom-cursor" @click="setServiceToUpdate(index, indexItem)"></td>
              <td class="mdi mdi-delete mdi-24px custom-cursor" @click="removeContractItem(index, indexItem)"></td>
            </tr>
          </tbody>
        </table>
        <div class="area-new" @click="openDialogItem(index)">
          <span style="margin-top: 6px; color: gray; font-weight: bold;">Clique aqui para adicionar item para o
            serviço</span>
        </div>
      </div>
    </div>
    <div v-if="!services || services.length == 0">
      <jt-empty-message :message="$gettext('NO_CONTRACT_SERVICES')" size="10em" />
    </div>
    <q-dialog v-if="flModal" v-model="flModal" maximized>
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("CONTRACT_SERVICE")
              }}</q-toolbar-title>
            <q-btn @click="resetServiceToLastSave" flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <ContractServiceFormPage @confirm="confirmContractService($event)"></ContractServiceFormPage>
        </q-page-container>
      </q-layout>
    </q-dialog>

    <q-dialog v-if="flModalItem" v-model="flModalItem" maximized>
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{
              $gettext("CONTRACT_ITEM")
              }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container class="card-container-modal">
          <ContractItemFormPage :updateItem="updateItem"
            :residueCarrierDestinationAlreadyUsed="residueCarrierDestinationAlreadyUsed"
            @confirm="confirmContractItem($event)" />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtEmptyMessage } from 'jtech-webcomps'
import { messageBox } from 'jtech'
import ContractDetail from '../contract/ContractDetail'
import ContractUpdate from '../contract/ContractUpdate'
import ContractPageTable from '../contract/ContractPageTable'
import ContractRegisterPage from '../contract/ContractRegisterPage.vue'
import ContractServiceFormPage from './ContractServiceFormPage.vue'
import ContractItemFormPage from './ContractItemFormPage.vue'
import { buildContractItemUniquenessCombination } from './utilsFunction'
import { serviceTypeStatus } from 'src/shared/inf-tabela-descricao/ServiceType.enum'

const { pageDetail, CrudLayoutSearch } = JtCrud
@Component({
  mixins: [pageDetail],
  name: 'ContractServiceRegister',
  components: { JtEmptyMessage, CrudLayoutSearch, ContractDetail, ContractUpdate, ContractPageTable, ContractRegisterPage, ContractServiceFormPage, ContractItemFormPage },
  props: {
    id: String,
    interface: String,
    name: String,
    contract: {
      type: Object,
      default: () => { return {} }
    },
    updateContract: {
      type: Object,
      default: () => { return {} }
    },
    isAdditiveOrRenovation: {
      type: Boolean,
      default: () => { return false }
    }
  }
})
class ContractServiceRegister extends Vue {
  contracts = [];
  services = [];
  flModal = false;
  flModalItem = false;
  selectedServiceIndex = null;
  fields = [];
  updateItem = {}
  residueCarrierDestinationAlreadyUsed = []

  @Watch('flModalItem')
  onChangeFlModalItem () {
    if (this.flModalItem === false) { this.closeDialogItem() }
  }

  mounted () {
    if (this.isAdditiveOrRenovation) {
      if (this.contract.services) {
        this.services = [...this.contract.services]
        this.$forceUpdate()
      }
    } else {
      this.UpdatingContract()
    }
  }

  getQuantityMessage (quantity) {
    return this.$gettext('FROM') + ' ' + quantity
  }

  getPriceMessage (value) {
    return this.$gettext('CONSIDER') + ' ' + this.$gettext('CURRENCY') + ' ' + value
  }

  getContractItemBillingTypeMessage (contractItemBillingType) {
    return this.$gettext('TYPE') + ' ' + this.$gettext(`CONTRACT_ITEM_BILLING_TYPE.${contractItemBillingType}`)
  }

  isValueRange (serviceType) {
    const serviceTypeEnum = serviceTypeStatus()
    return [serviceTypeEnum.RCC.key, serviceTypeEnum.FREIGHT.key, serviceTypeEnum.FREIGHT_APPORTIONMENT.key].includes(serviceType)
  }

  async UpdatingContract () {
    if (this.updateContract.services) {
      this.services = [...this.updateContract.services]
    }
  }

  setServiceToUpdate (indexService, indexItem) {
    this.updateItem = this.services[indexService].contractItems[indexItem]
    this.updateItem.updated = true
    this.setResidueCarrierDestinationAlreadyUsed(indexService)
    this.excludeCurrentResidueCarrierDestinationFromUniquenessCheck(indexService, indexItem)
    this.selectedServiceIndex = indexService
    this.selectedItemIndex = indexItem
    this.flModalItem = true
  }

  created () {
    this.fields = [
      this.$gettext('LANDFILL_NAME'),
      this.$gettext('WASTE_TYPE'),
      this.$gettext('PRODUCT_DESCRIPTION'),
      this.$gettext('ITEM_VALUE'),
      this.$gettext('MINIMUM_BILLING'),
      this.$gettext('BID_QTD'),
      this.$gettext('CALCULATION')
    ]
  }

  confirmContractService (contractService) {
    if (this.isServiceTypeUniqueInsideObject(contractService)) {
      return
    }
    this.closeDialog()
    this.services.push(contractService)
    this.updateItem = {}
    this.$emit('confirm', contractService)
  }

  isServiceTypeUniqueInsideObject (contractService) {
    if (this.services.some((service) => service.serviceType == contractService.serviceType)) {
      messageBox.warn(this.$gettext('SERVICE_TYPE_ALREADY_REGISTERED'))
      return true
    }
    return false
  }

  confirmContractItem (contractItem) {
    this.closeDialogItem()
    if (!this.services[this.selectedServiceIndex].contractItems) this.services[this.selectedServiceIndex].contractItems = []
    if (!contractItem.updated) {
      this.services[this.selectedServiceIndex].contractItems = [...(this.services[this.selectedServiceIndex].contractItems || []), contractItem]
    } else {
      this.services[this.selectedServiceIndex].contractItems.splice(this.selectedItemIndex, 1, contractItem)
    }
    this.selectedServiceIndex = null
    this.selectedItemIndex = null
    this.updateItem = {}
  }

  resetServiceToLastSave () {
    this.closeDialog()
    if (this.updateContract.services && Object.keys(this.updateContract.services).length > 0) {
      this.services = []
      this.services.push(this.updateContract.services)
    }
  }

  openDialog () {
    this.flModal = true
  }

  closeDialog () {
    this.flModal = false
  }

  openDialogItem (index) {
    this.updateItem = { ...this.updateItem, serviceType: this.services[index].serviceType, updated: false }
    this.setResidueCarrierDestinationAlreadyUsed(index)
    this.selectedServiceIndex = index
    this.flModalItem = true
  }

  setResidueCarrierDestinationAlreadyUsed (serviceTypeIndex) {
    const contractItems = this.getContractItems(serviceTypeIndex)

    if (contractItems?.length === 0) {
      return
    }

    const residueCarrierDestinationAlreadyUsed = contractItems.map(e => (buildContractItemUniquenessCombination(e)))
    this.residueCarrierDestinationAlreadyUsed = residueCarrierDestinationAlreadyUsed || []
  }

  excludeCurrentResidueCarrierDestinationFromUniquenessCheck (serviceTypeIndex, contractItemIndex) {
    const contractItems = this.getContractItems(serviceTypeIndex)
    if (contractItems?.length === 0) return
    const serviceToRemove = this.services[serviceTypeIndex].contractItems[contractItemIndex]
    const serviceToRemoveKey = (buildContractItemUniquenessCombination(serviceToRemove))
    const indexFromServiceToRemove = this.residueCarrierDestinationAlreadyUsed.findIndex(item =>
      item.product === serviceToRemoveKey.product &&
      item.carrier === serviceToRemoveKey.carrier &&
      item.destination === serviceToRemoveKey.destination &&
      item.serviceType === serviceToRemoveKey.serviceType
    )
    this.residueCarrierDestinationAlreadyUsed.splice(indexFromServiceToRemove, 1)
  }

  getContractItems (serviceTypeIndex) {
    return this.services[serviceTypeIndex].contractItems || []
  }

  closeDialogItem () {
    this.flModalItem = false
    this.updateItem = {}
    this.residueCarrierDestinationAlreadyUsed = []
  }

  removeService (index) {
    this.services.splice(index, 1)
    this.contract.services = [...this.services]
  }

  removeContractItem (indexService, indexContractItem) {
    this.services[indexService].contractItems.splice(indexContractItem, 1)
    this.services = [...this.services]
    this.contract.services = this.services
  }

  hasBillingItems (contractItem) {
    return contractItem.contractItemBilling != null && contractItem.contractItemBilling.length > 0
  }

  getValueTextFromBillingItems (contractItemBilling) {
    return this.$gettext('CURRENCY') + ' ' + contractItemBilling.value
  }

  getValueTextPrice (contractItem) {
    return this.$gettext('CURRENCY') + ' ' + contractItem.unitPrice
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return ContractUpdate
  }

  get pageDetail () {
    return ContractDetail
  }

  get pageTable () {
    return ContractPageTable
  }
}
export default ContractServiceRegister
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.value-text {
  background-color: rgb(212, 212, 216)
  margin-right: 2px
}

.contract-client {
.buttons-top-crud {
    padding: 10px 14px;
}

.q-table th, .q-table td {
    padding: 0px 10px !important;
}

}

@media only screen and (max-height: 750px) {
.contact-client {
    .table-crud .jt-datatable {
    padding-bottom: 0px;
    }
}
}

.tabela {
width: 100%;
border-collapse: collapse;
margin: 20px auto;
}

.tabela th, .tabela td {
padding: 12px;
text-align: left;
}

.tabela th {
background-color: #F2F4F5;
border-bottom: 2px solid #dddddd;
}

.tabela tr:hover {
background-color: #f0f0f0;
}

.table-row-divider {
border-bottom: 1px solid #ddd;

}
.custom-cursor {
cursor: pointer;
}
.area-new {
    width: 100%;
    border-bottom: 2px dashed gray;
    border-left: 2px dashed gray;
    border-right: 2px dashed gray;
    border-top: 2px solid gray;
    border-radius: 0px 0px 10px 10px;
    padding: 15px; text-align: center;
    cursor: pointer;
}
.area-new:hover {
    background: #ECECEC;
}
.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  width: 130px;
  cursor: pointer;
}
.tooltip-range-area {
  display: flex;
}
.tooltip-range-item {
  background: black;
  padding: 5px;
  border-radius: 5px;
  margin-left: 5px;
}
</style>
